import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import { getPost, postPath, PUBLISHED } from '../../content/blog';
import { localeFromPath } from '../../lib/i18n-routes';

/**
 * Bosh sahifadagi maqolalar bloki — eng yangi 3 tasi.
 * Ma'lumot `src/content/blog` reyestridan olinadi.
 */
function Blog({ limit = 3 }) {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const locale = localeFromPath(pathname);

    const items = PUBLISHED
        .map((p) => ({ ...p, content: getPost(p.slug, locale) }))
        .filter((p) => p.content)
        .sort((a, b) => (a.date < b.date ? 1 : -1))
        .slice(0, limit);

    if (!items.length) return null;

    const blogRoot = locale === 'ru' ? '/ru/blog' : '/blog';

    return (
        <section className="tf-section blog">
            <div className="container">
                <div className="tf-title mb-50" data-aos="zoom-in" data-aos-duration="800">
                    <p className="h8 sub-title">{t('news')}</p>
                    <h2 className="title">{t('useful-info')}</h2>
                </div>

                <div className="blog-list__grid">
                    {items.map((p) => (
                        <Link className="blog-card" key={p.slug} to={postPath(p, locale)}>
                            {p.content.images?.[0] ? (
                                <span className="blog-card__img">
                                    <img
                                        src={p.content.images[0].src}
                                        alt={p.content.images[0].alt}
                                        width="1400"
                                        height="875"
                                        loading="lazy"
                                        onError={(e) => { e.currentTarget.parentNode.style.display = 'none'; }}
                                    />
                                </span>
                            ) : null}
                            <span className="blog-card__body">
                                <span className="blog-card__tag">{p.content.category}</span>
                                <h3 className="blog-card__title">{p.content.h1}</h3>
                                <span className="blog-card__lead">{p.content.lead}</span>
                                <span className="svc-related__more">{t('read-more')} &#8599;</span>
                            </span>
                        </Link>
                    ))}
                </div>

                <div className="work-all">
                    <Link to={blogRoot} className="tf-button btn-effect">
                        <span className="effect">{t('all-articles')}</span>
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default Blog;
